import { object, string, date } from "yup";

const siteDiarySiteDetailsSchema = object({
  hwrcSite: string()
});

export default siteDiarySiteDetailsSchema;
